/** The new UI is the default on both sites. Cookies override for seven days. */
export const FLAG_KEY = 'santa_v2';
export const COOKIE_NAME = 'ss_fe';

function cookieVersion(): boolean {
  const preference = /(?:^|;\s*)ss_fe=(v1|v2)(?:;|$)/.exec(document.cookie)?.[1];
  if (preference) return preference === 'v2';
  return true;
}

function setVersion(on: boolean): void {
  // Cookies select the server response even if localStorage is unavailable.
  document.cookie = `${COOKIE_NAME}=${on ? 'v2' : 'v1'};path=/;max-age=604800;samesite=lax`;
  try { localStorage.setItem(FLAG_KEY, on ? '1' : '0'); } catch { /* Cookie remains usable. */ }
}

export function reconcileVersionFlag(): boolean {
  try {
    const url = new URL(window.location.href);
    const forced = url.searchParams.get('v2');
    const wantV2 = forced === '0' ? false : forced === '1' ? true
      : cookieVersion();
    const changed = wantV2 !== cookieVersion();
    if (forced === '0' || forced === '1' || changed) setVersion(wantV2);
    if (forced === '0' || forced === '1') url.searchParams.delete('v2');
    const clean = url.pathname + url.search + url.hash;
    // A blocked cookie jar cannot apply the override. Never reload endlessly.
    if (changed && wantV2 === cookieVersion()) {
      window.location.replace(clean);
      return true;
    }
    if (forced === '0' || forced === '1') window.history.replaceState(window.history.state, '', clean);
    return false;
  } catch { return false; }
}

export function installVersionFlagHelper(): void {
  (window as unknown as { __santaUseV2?: (on?: boolean) => void }).__santaUseV2 = (on = true) => {
    setVersion(on);
    window.location.reload();
  };
}

export function switchToV1(): void {
  setVersion(false);
  // Profiles is new-UI-only; the legacy account page is its closest equivalent.
  if (window.location.pathname === '/account/profiles') window.location.assign('/account');
  else window.location.reload();
}
